import { FlightsExchangeApp } from "@b2bportal/core-flights";
import {
  FlightsExchangeCheckout,
  flightExchangeCheckoutProps,
} from "@hsbc/flights";

export const FlightsExchangePage = () => {
  const CheckoutPage = () => (
    <FlightsExchangeCheckout
      clientAssets={{}}
      {...flightExchangeCheckoutProps}
    />
  );

  return <FlightsExchangeApp CheckoutPage={<CheckoutPage />} />;
};
